/* =======================================================================
  Reading query parameters and storing them in a Shopify.queryParams object.
  Necessary for collection sorting and advanced collection filtering.
======================================================================= */

Shopify.queryParams = {};
if (location.search.length) {
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&');
    i < aCouples.length;
    i++
  ) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[
        decodeURIComponent(aKeyValue[0])
      ] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

$('.shopify-currency-form select').on('change', function () {
  $(this).parents('form').submit();
});

var nav = document.getElementById('primarynav');

nav.addEventListener('change', function () {
  if (this.checked) {
    document.documentElement.style.overflow = 'hidden';
  } else {
    document.documentElement.style.overflow = 'visible';
  }
});

// $('.collection__filters--expand').prev().hide().siblings('li:not(.collection__filters--expand):not(.collection__filters--nexttoexpand)').addClass('collection__filters--nexttoexpand');

// var collectionlinks = $('.collection__filters--wrapper').find('a');
// if(collectionlinks.length <= 1) {
//   $('.collection__filters').hide();
// } else {
//   collectionlinks.each(function() {
//     if(this.href == location.href) {
//       $(this).addClass('current-tag');
//     }
//   })
// }
